"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Profile = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Profile_1 = require("../../../sections/profile/mobile/Profile");
const Profile = ({ title }) => {
    return (0, jsx_runtime_1.jsx)(Profile_1.MobileProfile, {});
};
exports.Profile = Profile;
